export const MAX_CONCURRENCY = 1000
export const DEFAULT_EVALUATION_MAX_CONCURRENCY = 100

interface EvaluationConcurrencyCovalIntegration {
  max_job_concurrency?: number
}

export function getEvaluationMaxJobConcurrency(
  covalIntegration: EvaluationConcurrencyCovalIntegration | null | undefined,
): number {
  const maxJobConcurrency = covalIntegration?.max_job_concurrency
  const normalizedMaxJobConcurrency =
    typeof maxJobConcurrency === "number" && Number.isFinite(maxJobConcurrency)
      ? Math.trunc(maxJobConcurrency)
      : null

  if (normalizedMaxJobConcurrency == null) {
    return DEFAULT_EVALUATION_MAX_CONCURRENCY
  }

  return Math.max(1, Math.min(normalizedMaxJobConcurrency, MAX_CONCURRENCY))
}
